module.exports = __webpack_public_path__ + "static/img/sangdi2.a2cf4711.png";